// extracted by mini-css-extract-plugin
export default {"mainSection":"addEditCVRecordWrapper_mainSection__CiA9N","actions":"addEditCVRecordWrapper_actions__GNrhS"};